import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { RDRClient } from '../../Models/Domains/Account/SlAccounts/RDRClient';

declare var IS_RUNNING_IN_APP_POOL;

export class ClientRDRClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(accountId: string): Promise<RDRClient, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/ClientRDR/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { accountId: accountId }

    return AjaxWrapper.get<RDRClient, any>(url, data);
  }
}

